import GlobalChannel from 'data/websocket/globalChannel';
import UserChannel from 'data/websocket/userChannel';
import PropertyChannel from 'data/websocket/propertyChannel';
import FolderChannel from 'data/websocket/folderChannel';

// SharedChannel initializes globally shared channels
export const globalChannel = new GlobalChannel();
export const userChannel = new UserChannel();
export const propertyChannel = new PropertyChannel();
export const folderChannel = new FolderChannel();
